"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_scale = void 0;
exports.foundation_scale = {
    small: {
        scale_small_none: 0,
        scale_small_5: 0.05,
        scale_small_10: 0.10,
        scale_small_15: 0.15,
        scale_small_20: 0.20,
    },
    medium: {
        scale_medium_25: 0.25,
        scale_medium_30: 0.30,
        scale_medium_35: 0.35,
        scale_medium_40: 0.40,
        scale_medium_45: 0.45,
        scale_medium_50: 0.50,
    },
    large: {
        scale_large_55: 0.55,
        scale_large_60: 0.60,
        scale_large_65: 0.65,
        scale_large_70: 0.70,
        scale_large_75: 0.75,
        scale_large_80: 0.80,
        scale_large_85: 0.85,
        scale_large_90: 0.90,
        scale_large_95: 0.95,
        scale_large_100: 1,
    },
};
//# sourceMappingURL=scale.js.map